export default "__VITE_ASSET__CjUxUVLa__"